import { AutoComplete, Spin, SelectProps } from 'antd';
import { isArray, debounce } from 'lodash';
import React, { FC, useState } from 'react';
import { PropsWithStyle } from './types';

export interface RemoteCompleteUserSelectorProps<T = any> extends SelectProps<T> {
  wait?: number;
  fetcher?: (search: string) => Promise<{ label: string, value: string }[]>;
}

export const RemoteCompleteUserSelector: FC<PropsWithStyle<RemoteCompleteUserSelectorProps>> = (props) => {
  const { wait = 500, fetcher, ...resetProps } = props;
  const [options, setOptions] = useState<any>([]);
  const [fetching, setFetching] = React.useState(false);
  const fetchRef = React.useRef(0);

  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value: string) => {
      if (!value.trim()) {
        setOptions([]);
        setFetching(false);
        return;
      }
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setFetching(true);
      setOptions([]);
      fetcher?.(value).then((userList) => {
        const formatUserList = !isArray(userList) ? [] : userList;
        if (fetchId !== fetchRef.current) {
          return;
        }

        setOptions(formatUserList);
        setFetching(false);
      });
    };

    return debounce(loadOptions, wait);
  }, []);

  return (
    <AutoComplete
      filterOption={false}
      onSearch={debounceFetcher}
      onChange={props.onChange}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      options={options}
      {...resetProps}
    />
  );
};
